import { Box, Tab, tabsClasses, useMediaQuery } from "@mui/material";
import { TabsWrapper } from "assets/styles/globalStyledComponent";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import BulkPromotion from "./BulkPromotion";
import OneByOne from "./OneByOne";
import React from "react";

export default function PromotionAndMigration() {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {/* <Container maxWidth="xl" disableGutters={isMobile ? true : false}> */}
      <TabContext value={value}>
        <TabsWrapper sx={{ width: isMobile ? "100%" : "auto" }}>
          <TabList
            variant="scrollable"
            scrollButtons={isMobile}
            allowScrollButtonsMobile
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
              width: isMobile ? "85vw" : "auto",
            }}
            aria-label="ekalsutra erp tab"
            onChange={handleChange}
          >
            <Tab label="One By One" value="1" />
            <Tab label="Bulk Promotion" value="2" />
          </TabList>
        </TabsWrapper>
        {/* one by one promotion */}
        <TabPanel value="1" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 1 }}>
            <OneByOne />
          </Box>
        </TabPanel>
        {/* bulkPromotion */}
        <TabPanel value="2" sx={{ p: "0 !important" }}>
          <Box sx={{ my: 1 }}>
            <BulkPromotion />
          </Box>
        </TabPanel>
      </TabContext>
      {/* </Container> */}
    </>
  );
}
